<!--
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-07 15:55:40
 * @LastEditors: zcy
 * @LastEditTime: 2022-03-01 15:47:54
-->
<template>
  <div class="page-main">
    <div class="page-type-switch">
      <div
        :class="pageType === 'time' ? 'type-activite' : ''"
        @click="pageType = 'time'"
      >
        实时存塘量
      </div>
      <div
        :class="pageType === 'month' ? 'type-activite' : ''"
        @click="pageType = 'month'"
      >
        月存塘成本
      </div>
    </div>
    <!-- 实时存塘量 -->
    <TimePage v-if="pageType === 'time'" />
    <!-- 月存塘成本 -->
    <MonthPage v-if="pageType === 'month'" />
  </div>
</template>

<script>
import MonthPage from "./month-page.vue";
import TimePage from "./time-page.vue";
export default {
  data() {
    return {
      pageType: "time", //time实时存塘量 month月存塘成本
    };
  },
  components: {
    MonthPage,
    TimePage,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped></style>


